import { FieldType } from '@databases/model/field';
import { MutableValue, Value, ValueJSON } from '@databases/model/value';

import { YStringValue } from './y-string-value';

export class YNumberValue
  extends YStringValue<FieldType.Number>
  implements Value<FieldType.Number>, MutableValue<FieldType.Number>
{
  static fromJSON(json: ValueJSON<FieldType.Number, string>) {
    return new YNumberValue(YStringValue.mapFromJSON(json));
  }
}
